export default __webpack_public_path__ + "static/media/icon_withdraw_active.1e16a67d.svg";